import React, { useState } from "react";
import {
  Drawer,
  Typography,
  IconButton,
  Divider,
  TextField,
  Button,
  Box,
  List,
  ListItem,
  Avatar,
  makeStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import PersonIcon from "@material-ui/icons/Person";

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 500,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
  },
  header: {
    padding: "20px 24px 16px",
    borderBottom: "1px solid #e0e0e0",
  },
  title: {
    fontWeight: 600,
    fontSize: "18px",
    color: "#333",
    marginBottom: "4px",
  },
  subtitle: {
    fontWeight: "500",
    fontSize: "18px",
    color: "#333",
    marginBottom: "20px",
  },
  content: {
    flex: 1,
    padding: "20px 24px",
    overflow: "auto",
  },
  memberItem: {
    padding: "12px 0",
    display: "flex",
    alignItems: "center",
    // borderBottom: "1px solid #f5f5f5",
    // "&:last-child": {
    //   borderBottom: "none",
    // },
  },
  avatar: {
    width: 40,
    height: 40,
    marginRight: "12px",
    backgroundColor: "#e3f2fd",
    color: "#1976d2",
  },
  memberInfo: {
    flex: 1,
  },
  memberName: {
    fontWeight: 600,
    fontSize: "14px",
    color: "#333",
    marginBottom: "2px",
  },
  memberRole: {
    fontSize: "12px",
    color: "#666",
  },
  footer: {
    padding: "16px 24px",
    // borderTop: "1px solid #e0e0e0",
    display: "flex",
    justifyContent: "flex-end",
  },
  closeButton: {
    backgroundColor: "#1976d2",
    color: "#fff",
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "4px",
    padding: "10px 32px",
    "&:hover": {
      backgroundColor: "#1565c0",
    },
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#1976d2",
    borderRadius: "4px",
    padding: "8px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #1976d2",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
}));

// MOCK DATA for existing team members
// const MOCK_TEAM_MEMBERS = [
//   { 
//     id: 1, 
//     name: "Alexander Rios", 
//     role: "Corporate Quality Assurance - Head",
//     avatar: "AR",
//     isNew: false 
//   },
//   { 
//     id: 2, 
//     name: "Russell Cameron", 
//     role: "Corporate Quality Assurance - Head",
//     avatar: "RC",
//     isNew: false 
//   },
//   { 
//     id: 3, 
//     name: "Benita Wilkins", 
//     role: "Corporate Quality Assurance - Manager",
//     avatar: "BW",
//     isNew: false 
//   },
//   { 
//     id: 4, 
//     name: "Yvette Lang", 
//     role: "Corporate Quality Assurance - Manager",
//     avatar: "YL",
//     isNew: false 
//   },
//   { 
//     id: 5, 
//     name: "Allison Gill", 
//     role: "GS/CM - Site Manager",
//     avatar: "AG",
//     isNew: false 
//   },
// ];

const AssociatedTeammembersDrawer = ({ open, onClose, teamMembers,cmo}) => {
  const classes = useStyles();
  // const [teamMembers, setTeamMembers] = useState(teamMembers);
  const [editMode, setEditMode] = useState(false);

  // // Add new team member
  // const handleAddMember = () => {
  //   setTeamMembers([
  //     ...teamMembers,
  //     {
  //       id: Date.now(),
  //       name: "",
  //       role: "",
  //       avatar: "NM",
  //       isNew: true,
  //     },
  //   ]);
  //   setEditMode(true);
  // };

  // Delete team member
  // const handleDeleteMember = (id) => {
  //   setTeamMembers(teamMembers.filter((member) => member.id !== id));
  // };

  // Update team member
  // const handleMemberChange = (id, field, value) => {
  //   setTeamMembers(
  //     teamMembers.map((member) =>
  //       member.id === id ? { ...member, [field]: value } : member
  //     )
  //   );
  // };

  // Save changes
  // const handleSave = () => {
  //   setTeamMembers(teamMembers.map((member) => ({ ...member, isNew: false })));
  //   setEditMode(false);
  // };

  const getInitials = (name) => {
    if (!name) return "NM";
    return name.split(" ").map(n => n[0]).join("").toUpperCase();
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
   
      <div className={classes.drawer}>
        <div className={classes.header}>
          <Typography className={classes.title}>
            {cmo} Pharmaceuticals
          </Typography>
          
        </div>
        <Divider />
        <div className={classes.content}>
          <Typography className={classes.subtitle}>
            Associated Sponsor Team Members
          </Typography>
           <List style={{ padding: 0 }}>
            {teamMembers.length > 0 ? (
              teamMembers.map((member) => (
                <ListItem key={member.saasUserID} className={classes.memberItem}>
                  <Avatar className={classes.avatar}>
                    {member.userName
                      ? member.userName.split(" ").map(n => n[0]).join("").toUpperCase()
                      : "NM"}
                  </Avatar>
                  <div className={classes.memberInfo}>
                    <Typography className={classes.memberName}>
                      {member.userName}
                    </Typography>
                    <Typography className={classes.memberRole}>
                      {member.collaboratorRoleName}
                    </Typography>
                  </div>
                </ListItem>
              ))
            ) : (
              <Typography>No team members found.</Typography>
            )}
          </List>
        
        </div>
        
        <div className={classes.footer}>
          <Button
            variant="contained"
            onClick={onClose}
            className={classes.closeButton}
          >
            Close
          </Button>
        </div>
      </div>
 
    </Drawer>
  );
};

export default AssociatedTeammembersDrawer;